import { asyncThunkCreator, buildCreateSlice } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const registrantsSlice = createAppSlice({
  name: 'registrants',
  initialState,
  reducers,
});
//TODO IAN: move fetchProjectCourses once courses work is compelte
export const { fetchRegistrants, fetchProjectCourse, setPersonCourseCompletionState, resetRegistrants } =
  registrantsSlice.actions;

export default registrantsSlice.reducer;
